<template>
  <d2-container>
    <template slot="header">横坐标的倾斜</template>
    <div class="inner">
      <ve-line :data="chartData" :extend="extend" v-bind="pubSetting"></ve-line>
    </div>
    <template slot="footer">
      <d2-link-btn title="更多示例和文档" link="https://v-charts.js.org"/>
    </template>
  </d2-container>
</template>

<script>
import list from '@/pages/demo/charts/list/_mixin/list.js'
export default {
  mixins: [
    list
  ],
  data: function () {
    this.extend = {
      'xAxis.0.axisLabel.rotate': 45
    }
    return {
      chartData: {
        columns: ['日期', '访问用户', '下单用户', '下单率'],
        rows: [
          { '日期': '1/1', '访问用户': 1393, '下单用户': 1093, '下单率': 0.32 },
          { '日期': '1/2', '访问用户': 3530, '下单用户': 3230, '下单率': 0.26 },
          { '日期': '1/3', '访问用户': 2923, '下单用户': 2623, '下单率': 0.76 },
          { '日期': '1/4', '访问用户': 1723, '下单用户': 1423, '下单率': 0.49 },
          { '日期': '1/5', '访问用户': 3792, '下单用户': 3492, '下单率': 0.323 },
          { '日期': '1/6', '访问用户': 4593, '下单用户': 4293, '下单率': 0.78 },
          { '日期': '1/7', '访问用户': 1393, '下单用户': 1093, '下单率': 0.32 },
          { '日期': '1/8', '访问用户': 3530, '下单用户': 3230, '下单率': 0.26 },
          { '日期': '1/9', '访问用户': 2923, '下单用户': 2623, '下单率': 0.76 },
          { '日期': '1/10', '访问用户': 1723, '下单用户': 1423, '下单率': 0.49 },
          { '日期': '1/11', '访问用户': 3792, '下单用户': 3492, '下单率': 0.323 },
          { '日期': '1/12', '访问用户': 4593, '下单用户': 4293, '下单率': 0.78 }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.inner {
  position: absolute;
  top: 20px;
  right:  20px;
  bottom: 20px;
  left: 20px;
}
</style>
